"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
exports.DEFUALT_COLORS = [
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#607d8b',
];
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 ", ";\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  margin: 0 ", ";\n  display: flex;\n  flex-wrap: wrap;\n"])), polished_1.rem(5));
var DotWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: scale(1);\n  transition: transform 100ms ease;\n  width: ", ";\n  height: ", ";\n"], ["\n  margin: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: scale(1);\n  transition: transform 100ms ease;\n  width: ", ";\n  height: ", ";\n"])), polished_1.rem(5), polished_1.rem(40), polished_1.rem(40));
exports.Dot = styled_components_1.default('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border-radius: 50%;\n  transition: 0.1s;\n  transition: 0.1s;\n  width: ", ";\n  height: ", ";\n\n  &:hover {\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n  }\n\n  ", ";\n"], ["\n  border-radius: 50%;\n  transition: 0.1s;\n  transition: 0.1s;\n  width: ", ";\n  height: ", ";\n\n  &:hover {\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n  }\n\n  ",
    ";\n"])), polished_1.rem(35), polished_1.rem(35), polished_1.rem(40), polished_1.rem(40), function (props) {
    if (props.color) {
        if (props.selected) {
            return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          border: ", " solid ", ";\n        "], ["\n          border: ", " solid ", ";\n        "])), polished_1.rem(3), props.color);
        }
        return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), props.color);
    }
    return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.form.labelColor;
    });
});
exports.default = (function (props) {
    var className = props.className, value = props.value, onChange = props.onChange, _a = props.colors, colors = _a === void 0 ? exports.DEFUALT_COLORS : _a, otherProps = __rest(props, ["className", "value", "onChange", "colors"]);
    return (React.createElement(Wrapper, __assign({ className: className }, otherProps), colors.map(function (color) {
        return (React.createElement(DotWrapper, { key: color },
            React.createElement(exports.Dot, { color: color, selected: value === color, onClick: function () { return onChange(color); } })));
    })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
